module.exports = __webpack_public_path__ + "img/349.d3a2b228.jpg";